import { render, staticRenderFns } from "./localTradingView.vue?vue&type=template&id=4620b54c&"
import script from "./localTradingView.vue?vue&type=script&lang=js&"
export * from "./localTradingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports